import {ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {RestDataService} from '../../../services/rest-data.service';
import {SmallSelectItem} from '../../../services/common-datatypes';
import {RequiredInput} from '../../../decorators/common.decorators';
import {marker as _} from '@biesbjerg/ngx-translate-extract-marker';

@Component({
    selector: 'app-department-select',
    templateUrl: './department-select.component.html',
    styleUrls: ['./department-select.component.scss']
})
export class DepartmentSelectComponent implements OnInit {
    public selectList: SmallSelectItem[] = [];

    @Input() inline = false;
    @Input() autoOpen = false;
    @Input() multiple = false;
    @Input() onlyWritable = false;
    @Input() allowEmpty = true;
    @Input() translationPrefix = 'select.department';
    @Input() @RequiredInput selectedItems!: SmallSelectItem[];
    @Output() selectedItemsChange = new EventEmitter<SmallSelectItem[]>();

    private lastOnlyWritable: boolean = false;

    constructor(private changeDetectorRef: ChangeDetectorRef,
                private dataService: RestDataService) {
        _('select.department.name');
        _('select.department.all');
    }

    ngOnInit() {
        this.loadData();
    }

    loadData() {
        if ((0 === this.selectList.length) || (this.lastOnlyWritable !== this.onlyWritable)) {
            this.lastOnlyWritable = this.onlyWritable;
            this.dataService.getDepartments(this.onlyWritable).then((data: SmallSelectItem[]) => {
                const newList: SmallSelectItem[] = [];
                if (data && (0 < data.length)) {
                    data.forEach((item) => {
                        const newItem = new SmallSelectItem();
                        newItem.updateFromJson(item);
                        newList.push(newItem);
                    });
                }
                this.selectList = newList;
            });
        }
    }

    updateData() {
        this.selectedItemsChange.emit(this.selectedItems);
    }

}
